module.exports = __webpack_public_path__ + "images/icons_v2/juul-pod-pack-double-green-7f9701ea.svg";